import axios from 'axios';

let Api_Url="";

const setApiUrl = (url) => {
  Api_Url = url;
};

const Dashboard_Service = {
  setApiUrl,
  getAll: (param) => axios.get(`${Api_Url}?data=${param}`),
  getById: (id) => axios.get(`${Api_Url}/${id}`),
  create: (data) => axios.post(Api_Url, data),
  //update: (id, data) => axios.put(`${Api_Url}/${id}`, data),
  remove: (catId,catName,opFlag) => axios.delete(`${Api_Url}/${catId}/${catName}/${opFlag}`),


  getVisibleMenus: (groupId) => axios.get(`${Api_Url}/VisibleMenus/${groupId}`),
};

export default Dashboard_Service;
